var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1023 1.75001C10.7546 1.74891 10.4101 1.81691 10.0889 1.95006C9.76762 2.08321 9.47605 2.27886 9.23106 2.52564L1.97169 9.78439C1.87857 9.87765 1.81732 9.99797 1.79669 10.1281L1.25731 13.5269C1.24176 13.6244 1.24954 13.7242 1.28 13.8181C1.31046 13.9121 1.36275 13.9974 1.43257 14.0673C1.50239 14.1371 1.58776 14.1894 1.68169 14.2198C1.77562 14.2503 1.87542 14.2581 1.97294 14.2425L5.37481 13.7031C5.50498 13.6825 5.62529 13.6213 5.71856 13.5281L12.9742 6.26876C13.3443 5.89828 13.5963 5.42635 13.6982 4.91265C13.8001 4.39895 13.7474 3.86657 13.5466 3.38285C13.3459 2.89913 13.0063 2.4858 12.5706 2.19515C12.135 1.90451 11.6229 1.74959 11.0992 1.75001H11.1023ZM4.97481 12.5L2.62481 12.875L2.99981 10.5269L8.24356 5.28251L10.2198 7.25876L4.97481 12.5ZM12.0904 5.38501L11.1029 6.37501L9.12481 4.39689L10.1129 3.40939C10.3791 3.15535 10.7328 3.01361 11.1007 3.01361C11.4687 3.01361 11.8224 3.15535 12.0886 3.40939C12.2184 3.53906 12.3213 3.69305 12.3916 3.86254C12.4619 4.03204 12.498 4.21372 12.498 4.3972C12.498 4.58068 12.4619 4.76236 12.3916 4.93186C12.3213 5.10135 12.2184 5.25534 12.0886 5.38501H12.0904Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilEdit);
export default __webpack_public_path__ + "static/media/pencilEdit.d72edff2fa142118590cba211e213df1.svg";
export { ForwardRef as ReactComponent };